import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CtaButtonProps = {
  label?: string;
  className?: string;
  variant?: 'solid' | 'light';
};
export function CtaButton({
  label = 'QUIERO ENTRENAR MI MENTE',
  className = '',
  variant = 'solid'
}: CtaButtonProps) {
  const styles = variant === 'solid' ? 'bg-bosque text-white hover:bg-[#264e33]' : 'bg-white text-bosque hover:bg-salvia/20';
  return <a href={CHECKOUT_URL} className={`group inline-flex items-center justify-center gap-3 rounded-full px-8 py-4 text-sm font-semibold tracking-wide shadow-soft transition-all duration-300 hover:shadow-lift focus:outline-none focus-visible:ring-4 focus-visible:ring-agua/60 sm:text-base ${styles} ${className}`} data-id="element-65" data-mp="qi7ixznzy6em">
      {label}
      <ArrowRightIcon className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" data-id="element-66" data-mp="19c37etmzmcyg" />
    </a>;
}